import { ISuportT1PlusDetail, IQcId } from "../types";
import { baseUrl } from "../../variables";


export const updateSuportDetail = async (formData: ISuportT1PlusDetail, contract: string): Promise<void> => {
    try {
             
      const response = await fetch(baseUrl + `/${contract}/Suport/${formData.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
  
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  